import { useState } from 'react';
import { useDatos } from '../../datos/DatosContext';
import { useRuta } from '../../lib/ruta';
import { formatearFecha } from '../../lib/fechas';
import { Icono } from '../../componentes/ui/Icono';
import { Cabecera, GrupoChips } from '../../componentes/ui/basicos';
import type { Sueno } from '../../modelo/tipos';

export function EtiquetasSueno({ sueno }: { sueno: Sueno }) {
  return (
    <>
      {sueno.emociones.map((e) => <span key={'e' + e} className="tag moss">{e}</span>)}
      {sueno.simbolos.map((s) => <span key={'s' + s} className="tag dusk">{s}</span>)}
    </>
  );
}

export function Suenos() {
  const { datos } = useDatos();
  const { ir } = useRuta();
  const [filtro, setFiltro] = useState('Todas');
  const lista = datos.suenos.filter((d) => filtro === 'Todas' || d.emociones.includes(filtro));

  return (
    <div className="stack-lg">
      <Cabecera
        antetitulo="Mi mundo onírico"
        titulo="Sueños"
        accion={<button className="btn primary" onClick={() => ir('/suenos/nuevo')}><Icono nombre="plus" />Nuevo sueño</button>}
      />
      <div className="stack-sm">
        <span className="lbl">Filtrar por emoción</span>
        <GrupoChips etiqueta="Filtrar por emoción" opciones={['Todas', ...datos.opciones.emocionesSuenos]} seleccion={filtro} onElegir={setFiltro} desplazable />
        <p className="muted small" style={{ margin: 0 }}>Estas opciones se leerán de tu Notion en cada carga: si cambias una emoción allí, cambiará aquí.</p>
      </div>
      <div className="stack-sm">
        {lista.map((d) => (
          <button key={d.id} className="listbtn" onClick={() => ir('/suenos/' + d.id)}>
            <span className="between">
              <span className="muted small">{formatearFecha(d.fecha)}</span>
              <span className={d.permitirIA ? 'tag dusk' : 'tag'}>{d.permitirIA ? 'IA permitida' : 'Sin permiso IA'}</span>
            </span>
            <span className="display" style={{ fontSize: 21 }}>{d.titulo}</span>
            <span className="row"><EtiquetasSueno sueno={d} /></span>
          </button>
        ))}
        {!lista.length ? <p className="muted">No hay sueños con esa emoción.</p> : null}
      </div>
    </div>
  );
}
